<template>
  <ProtocolRulesFour></ProtocolRulesFour>
</template>

<script>
import ProtocolRulesFour from "@/components/ProtocolRulesFour";
export default {
  components: {
    ProtocolRulesFour,
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/systemManagement/distributionRule/distributionRule.vue